import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-baseinfo",
  "use": "icon-menu-baseinfo-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-baseinfo\">\n<path d=\"M15.5163 3.46387C16.5462 3.46387 17.3296 4.38865 17.1603 5.40453L15.7714 13.7379C15.6375 14.5415 14.9421 15.1305 14.1274 15.1305H3.87261C3.05789 15.1305 2.36257 14.5415 2.22863 13.7379L0.83974 5.40453C0.670423 4.38865 1.45383 3.46387 2.48373 3.46387H15.5163ZM14 0.963867C14.4603 0.963867 14.8334 1.33697 14.8334 1.7972C14.8334 2.25743 14.4603 2.63053 14 2.63053H4.00004C3.53981 2.63053 3.16671 2.25743 3.16671 1.7972C3.16671 1.33697 3.53981 0.963867 4.00004 0.963867H14Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/menu-baseinfo.svg
// module id = 8QKm
// module chunks = 258